import Flickity from 'flickity';

import {register} from '../vendor/theme-scripts/theme-sections';
import debounce from '../util/debounce';
import slideToggle from '../util/slide-toggle';

const selectors = {
  sidebar: '.sidebar',
  widgetCategories: '.widget--categories',
  widgetCategoriesLinks: '.widget--categories .widget__links',
  widgetLinksEl: '.widget__links',
  widgetLinks: '.widget__links .has-sub-nav > a',
  widgetLinksSub: '.widget__links .submenu > li > a',
  listEl: 'li',
  linkEl: 'a',
  sliderEnabled: 'flickity-enabled',
  articleSingle: '.article--single',
  sidebarContents: '.sidebar__contents',
  hasSubNav: '.has-sub-nav',
  classOpen: 'open',
  classActive: 'active',
  classSubmenu: 'submenu',
};

const sections = {};

class Article {
  constructor(section) {
    this.container = section.container;
    this.sidebar = this.container.querySelector(selectors.sidebar);
    this.widgetCategories = this.container.querySelector(selectors.widgetCategories);
    this.flkty = null;

    this.init();
  }

  init() {
    if (this.sidebar) {
      this.sidebarNav();
    }
  }

  sidebarNav() {
    const self = this;

    this.navStates();

    // Dropdown Menus
    document.addEventListener('click', function (e) {
      const checkLinkTag = e.target.tagName.toLowerCase() === selectors.linkEl;
      const checkLinkParent = e.target.closest(`${selectors.listEl}${selectors.hasSubNav}`);
      const checkLinkClosest = e.target.closest(selectors.widgetLinksEl);
      const checkLink = checkLinkTag && checkLinkParent && checkLinkClosest;
      const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      const isMobile = windowWidth < 750;

      if (!isMobile && checkLink) {
        const submenu = e.target.nextElementSibling;

        submenu.parentElement.classList.toggle(selectors.classActive);
        submenu.classList.toggle(selectors.classOpen);
        slideToggle(submenu);

        self.checkAriaStatus(submenu);

        e.preventDefault();
      }
    });

    if (this.widgetCategories) {
      this.categories();

      window.addEventListener('resize', debounce(this.categories, 250));
    }
  }

  checkAriaStatus(submenu) {
    const state = submenu.classList.contains(selectors.classOpen);

    if (state) {
      submenu.setAttribute('aria-expanded', true);
    } else {
      submenu.setAttribute('aria-expanded', false);
    }
  }

  navStates() {
    // Nav Active States
    const links = this.container.querySelectorAll(selectors.widgetLinks);
    const subLinks = this.container.querySelectorAll(selectors.widgetLinksSub);

    links.forEach((element) => {
      const href = element.getAttribute('href');
      const location = window.location.pathname;

      if (href === location) {
        const elementClosest = element.closest(selectors.hasSubNav);
        elementClosest.classList.add(selectors.classActive);
        elementClosest.querySelector(`.${selectors.classSubmenu}`).style.display = 'block';
      }
    });

    subLinks.forEach((element) => {
      const href = element.getAttribute('href');
      const location = window.location.pathname;

      if (href === location) {
        const elementClosest = element.closest(selectors.hasSubNav);
        element.closest('li').classList.add(selectors.classActive);
        elementClosest.classList.add(selectors.classActive);
        elementClosest.querySelector(`.${selectors.classSubmenu}`).style.display = 'block';
      }
    });
  }

  categories() {
    const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    const isMobile = windowWidth < 750;
    const menuCategories = document.querySelector(selectors.widgetCategoriesLinks);
    const activeLink = menuCategories.querySelector(`${selectors.listEl}.${selectors.classActive}`);

    let activeLinkIdx = null;
    if (activeLink) {
      activeLinkIdx = Array.from(activeLink.parentElement.children).indexOf(activeLink);
    }

    const widgetCategories = document.querySelector(selectors.widgetCategories);

    this.navStates;

    this.flkty = new Flickity(menuCategories, {
      initialIndex: activeLinkIdx,
      autoPlay: false,
      prevNextButtons: true,
      contain: true,
      pageDots: false,
      wrapAround: true,
      watchCSS: true,
      arrowShape: {
        x0: 10,
        x1: 60,
        y1: 50,
        x2: 60,
        y2: 40,
        x3: 20,
      },
    });

    if (isMobile) {
      document.querySelector(selectors.articleSingle).prepend(widgetCategories);
    } else {
      document.querySelector(selectors.sidebarContents).prepend(widgetCategories);
    }
  }
}

const articleSection = {
  onLoad() {
    sections[this.id] = new Article(this);
  },
};

register('article', articleSection);
